<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import Icon from "@components/material/Icon.svelte"
    import Popup from "@components/popup/Popup.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"
    import PopupButtons from "@components/popup/PopupButtons.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupIcon from "@components/popup/PopupIcon.svelte"
    import PopupIconDivider from "@components/popup/PopupIconDivider.svelte"

    let open = false
    export let reason: "ios-frequent" | "temptations"
</script>

<a
    href="#"
    class="absolute opacity-70 right-0 h-full top-0"
    on:click|preventDefault={() => (open = true)}><Icon class="w-6" icon="information" /></a
>

{#if open}
    <Popup on:clickoutside={() => (open = false)}>
        <PopupBanner>
            <PopupExit on:exit={() => (open = false)} float />
            <PopupIconDivider>
                <div slot="icon">
                    <PopupIcon class="w-8 h-8 dark:text-black" icon="information" />
                </div>
                <PopupHeading>
                    {#if reason === "ios-frequent"}
                        This reminder is not available on iOS
                    {:else if reason === "temptations"}
                        Response to temptation reminders are not available yet
                    {/if}
                </PopupHeading>
            </PopupIconDivider>
        </PopupBanner>
        <p>
            {#if reason === "ios-frequent"}
                Because of iOS notification limits, this reminder type cannot be scheduled on your
                device.
            {:else if reason === "temptations"}
                We are still shaping how response-to-temptation prompts should work in the app.
            {/if}
        </p>
        <PopupButtons>
            <Button color="white" go={() => (open = false)}>Close</Button>
        </PopupButtons>
    </Popup>
{/if}
